export const EDIT_INVENTORY_ENDPOINTS = {
  UPDATE_CPM: '/api/v1/inventory/cpm',
};
